module.exports = __webpack_public_path__ + "img/Ido_Golding.758d7435.png";